"use client";
import { EmptyState } from "@/components/ui/EmptyState";
import { Button } from "@/components/ui/Button";
import { observeApplicationRecovery } from "@/utils/application-recovery-telemetry";
import { AlertTriangle } from "lucide-react";
import Link from "next/link";
import { useEffect } from "react";

export default function ErrorComponent() {
  useEffect(() => observeApplicationRecovery("fallback_displayed"), []);
  return (
    <div className="flex h-screen w-full items-center justify-center bg-bg-surface">
      <EmptyState
        icon={AlertTriangle}
        tone="danger"
        title="Something went wrong!"
        description="We apologize for the inconvenience. Please try again."
        action={
          <>
            <Button asChild variant="secondary">
              <Link href="/contact">Support</Link>
            </Button>
            <Button
              onClick={() => {
                observeApplicationRecovery("retry_initiated");
                window.location.reload();
              }}
            >
              Retry
            </Button>
          </>
        }
      />
    </div>
  );
}
